/* @flow */
import * as React from "react";
import Media from "react-media";
import styled, { css } from "styled-components";

import Gettext from "../common/Gettext";
import { Link } from "../common/Link";
import { withDeposit } from "../common/withDeposit";
import { PersonIcon } from "./Icons";
import ToggleNav from "./Hamburger";
import withData from "../withData";
import { getVerificationStatusIcon, getVerificationStatusText, VERIFICATION_STATUS_APPROVED } from "../VerificationStatus";
import TournamentApi from "../Tournaments/Api";

import type { Profile } from "../../redux/CommonTypes";

const Container = styled.div`
  position: relative;
  flex-grow: 0;
  flex-shrink: 0;
  background-color: ${props => props.theme.mainHighlight};
  width: 100%;

  @media (min-width: 960px) {
    border-left: 1px solid ${({ theme }) => theme.navigationBg};
  }
`;

const ProfileLink = styled(Link)`
  direction: ${({ theme }) => theme.direction};
  display: block;
  text-decoration: none;
  padding-top: 25px;
  padding-bottom: 26px;
  font-weight: 400;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 1;
  color: ${({ theme }) => theme.foreground};

  ${({ theme }) => {
    if (theme.direction === "rtl") {
      return css`
        padding-left: 20px;
        padding-right: 68px;
        text-align: right;
      `;
    }

    return css`
      padding-right: 20px;
      padding-left: 68px;
      text-align: left;
    `;
  }};

  @media (max-width: 959px) {
    padding-top: 17px;
    padding-bottom: 16px;

    ${({ theme }) => {
      if (theme.direction === "rtl") {
        return css`
          padding-left: 17px;
          margin-right: 48px;
          padding-right: 0;
        `;
      }

      return css`
        padding-right: 17px;
        margin-left: 48px;
        padding-left: 0;
      `;
    }};
  }
`;

const FlexContainer = styled.div`

`;

const ProfileID = styled.h2`
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  font-size: 14px;
  line-height: 1.2;
  color: ${({ theme }) => theme.navigationId};
  margin-bottom: 7px;
`;

const Email = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  align-self: flex-start;
  flex-basis: 100%;
  min-width: 0;
  max-width: 187px;
  line-height: 1.2;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.navigationUserName};
  margin-bottom: 6px;
  font-size: 14px;
  display: inline-block;
  text-decoration: none;
`;

const ProfileInfo = styled.div`
`;

const VerificationWrapper = styled.div`
  color: #a7a7a7;
  vertical-align: middle;
  display: flex;
  align-items: center;
`;

const VerificationText = styled.div`
  font-size: 12px;

  ${({ theme }) => {
      if (theme.direction === "rtl") {
        return css`
          margin-right: 8px;
        `;
      }

      return css`
        margin-left: 8px;
      `;
    }};

  ${props =>
    (props.status===0 || props.status===3) ?
    css`
      color: #e74c3c;
    ` :
    props.status===1 ?
    css`
      color: #FFCC00;
    ` :
    props.status===2 ?
    css`
      color: #60a21d;
    ` :
    css`
      color: inherit;
    `
  }
`;

const VerificationIcon = styled.div`
  line-height: 0;
`;

const ProfileIcon = styled.i`
  position: absolute;
  top: 21px;
  color: #3B9478;
  ${({ theme }) => {
    if (theme.direction === "rtl") {
      return css`
        right: 38px;
      `;
    }

    return css`
      left: 38px;
    `;
  }};

  @media (max-width: 959px) {
    display: none;
  }
`;

const NavWrapper = styled(ToggleNav)`
  position: absolute;
  top: 16px;
  margin-left: 0;
  margin-right: 0;
  color: ${({ theme }) => theme.navigationUserName};

  ${({ theme }) => {
    if (theme.direction === "rtl") {
      return css`
        right: 10px;
      `;
    }

    return css`
      left: 10px;
    `;
  }};
`;

type Props = {
  isVIP: boolean,
  trade?: boolean | void,
  showDeposit: boolean,
  onClick: () => void,
  onLocaleChange: (value: string) => void
};


function User(props: Profile & Props) {
  let api = React.useContext(TournamentApi);
  let features = api.readEntity("/api/features/list");

  const voluntaryVerification = features.status === "Pending"
    ? null
    : features.value &&
    features.value.find(feature => feature.name === "voluntary_verification");

  const onProfileClick = () => {
    if (window.location.pathname.indexOf("/profile") === 0) {
      props.onClick();
    }
  };

  return (
    <Container>
      <Media
        query="(max-width: 959px)"
        render={() => <NavWrapper onClick={props.onClick} />}
      />

      <ProfileLink to="/profile" onClick={onProfileClick}>
        <ProfileIcon>
          <PersonIcon />
        </ProfileIcon>

        <FlexContainer>
          <Email>{props.email}</Email>
          <ProfileInfo>

            <ProfileID hideLangSelect={props.hideLangSelect}><Gettext>Profile id</Gettext> {props.id}</ProfileID>

            {(voluntaryVerification === undefined || props.status === VERIFICATION_STATUS_APPROVED) && <VerificationWrapper>
              <VerificationIcon>
                {getVerificationStatusIcon(props.status)}
              </VerificationIcon>
              <VerificationText status={props.status}>
                {getVerificationStatusText(props.status)}
              </VerificationText>
            </VerificationWrapper>}

          </ProfileInfo>
        </FlexContainer>

      </ProfileLink>


    </Container>
  );
}

export default withData(["apiConfigs"])(withDeposit(User));



// WEBPACK FOOTER //
// ./src/components/Navigation/User.js